





















import { Vue, Component } from 'vue-property-decorator';
import PoweredByLogo from '../assets/powered-by-ga.svg';

@Component({
  components: {
    PoweredByLogo,
  },
})
export default class BottomBar extends Vue {
  handlePoweredByClick() {
    window.open('https://www.getaccept.com', '_blank');
  }
}
